// extracted by mini-css-extract-plugin
export default {"container":"banner-planos_container__-KtMq","lista-planos":"banner-planos_lista-planos__KjcSM"};